import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    categoriesList: {
      data: {},
      status: statuses.EMPTY,
    },
    category: {
      data: {},
      status: statuses.EMPTY,
    },
    categoryCreateData: {
      data: {},
      status: statuses.EMPTY,
    },
    categoryUpdateData: {
      data: {},
      status: statuses.EMPTY,
    },
    categoryCreate: {
      data: {},
      status: statuses.EMPTY,
    },
    categoryUpdate: {
      data: {},
      status: statuses.EMPTY,
    },
    productsList: {
      data: {},
      status: statuses.EMPTY,
    },
    product: {
      data: {},
      status: statuses.EMPTY,
    },
    productCreateData: {
      data: {},
      status: statuses.EMPTY,
    },
    productUpdateData: {
      data: {},
      status: statuses.EMPTY,
    },
    productCreate: {
      data: {},
      status: statuses.EMPTY,
    },
    productUpdate: {
      data: {},
      status: statuses.EMPTY,
    },
    productClassifiers: {
      data: {},
      status: statuses.EMPTY,
    },
    productUpdateActive: {
      data: {},
      status: statuses.EMPTY,
    },
  };
};

const ProcurementScheme = {
  namespaced: true,
  state: defaultState,
  getters: {
    categoriesList: (state) => state.categoriesList,
    category: (state) => state.category,
    categoryCreateData: (state) => state.categoryCreateData,
    categoryUpdateData: (state) => state.categoryUpdateData,
    categoryCreate: (state) => state.categoryCreate,
    categoryUpdate: (state) => state.categoryUpdate,
    productsList: (state) => state.productsList,
    product: (state) => state.product,
    productCreateData: (state) => state.productCreateData,
    productUpdateData: (state) => state.productUpdateData,
    productCreate: (state) => state.productCreate,
    productUpdate: (state) => state.productUpdate,
    productClassifiers: (state) => state.productClassifiers,
    productUpdateActive: (state) => state.productUpdateActive,
  },
  mutations,
  actions,
};

export { ProcurementScheme, defaultState };
